<template>
    <div class="row">
        <div class="col">
            <div class="card card-form company-card">
                <div class="card-header license">
                    <div class="row">
                        <div class="col-12">
                            <div class="pull-left">
                                <span><i class="fa fa-list"></i> {{$t('company.license.label')}}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-8">
                            <div class="form-group">
                                <label>{{$t('company.field.regNum')}} <span class="red">*</span></label>
                                <input type="text" class="form-control"
                                       v-model="companyLicenseForm.regNum"
                                       :class="{invalid: $v.companyLicenseForm.regNum.$error}"
                                >
                                <div class="red" v-if="!$v.companyLicenseForm.regNum.required">{{$t('company.validation.regNum')}}</div>
                                <div class="red" v-if="!$v.companyLicenseForm.regNum.maxLength">{{$t('company.validation.regNumConfirm')}}</div>
                            </div>
                            <div class="form-group">
                                <label>{{$t('company.field.serialNum')}} <span class="red">*</span></label>
                                <input type="text" class="form-control"
                                       v-model="companyLicenseForm.serialNum"
                                       :class="{invalid: $v.companyLicenseForm.serialNum.$error}"
                                >
                                <div class="red" v-if="!$v.companyLicenseForm.serialNum.required">{{$t('company.validation.serialNum')}}</div>
                                <div class="red" v-if="!$v.companyLicenseForm.serialNum.maxLength">{{$t('company.validation.serialNumConfirm')}}</div>
                            </div>
                            <div class="form-group">
                                <label>{{$t('company.field.dataNum')}} <span class="red">*</span></label>
                                <input type="text" class="form-control"
                                       v-model="companyLicenseForm.dataNum"
                                       :class="{invalid: $v.companyLicenseForm.dataNum.$error}"
                                >
                                <div class="red" v-if="!$v.companyLicenseForm.dataNum.required">{{$t('company.validation.dataNum')}}</div>
                                <div class="red" v-if="!$v.companyLicenseForm.dataNum.maxLength">{{$t('company.validation.dataNumConfirm')}}</div>
                            </div>
                            <div class="form-group">
                                <label>{{$t('company.field.giveName')}} <span class="red">*</span></label>
                                <textarea type="text" class="form-control"
                                       v-model="companyLicenseForm.giveName"
                                       :class="{invalid: $v.companyLicenseForm.giveName.$error}"
                                ></textarea>
                                <div class="red" v-if="!$v.companyLicenseForm.giveName.required">{{$t('company.validation.giveName')}}</div>
                                <div class="red" v-if="!$v.companyLicenseForm.giveName.maxLength">{{$t('company.validation.giveNameConfirm')}}</div>
                            </div>
                            <div class="form-group">
                                <label>{{$t('company.field.startDate')}} <span class="red">*</span></label>
                                <datepicker class="form-control" format="dd/MM/yyyy" v-model="startDate"
                                            :clear-button="false"
                                            :class="{invalid : $v.startDate.$error}"
                                ></datepicker>
                                <div class="red" v-if="!$v.startDate.required">{{$t('company.validation.startDate')}}</div>
                            </div>
                            <div class="form-group" v-if="hasCreate">
                                <label>{{$t('company.field.endDate')}} <span class="red">*</span></label>
                                <datepicker class="form-control" format="dd/MM/yyyy" v-model="endDate"
                                            :clear-button="false"
                                            :class="{invalid : $v.endDate.$error}"
                                ></datepicker>
                                <div class="red" v-if="!$v.endDate.required">{{$t('company.validation.endDate')}}</div>
                            </div>
                        </div>
                        <drop-zone code="companyLicensePictureFile_"
                                   label="company.field.companyLicensePicture"
                                   view="LOGO"
                                   folder="Profile"
                                   subFolder="General"
                                   :addRemoveLinks="hasCreate"
                                   :editable="hasCreate"
                                   :data="companyLicenseFiles"
                                   @change="(files) => {companyLicenseForm.companyLicensePictureFile = files[0]}"
                                   :maxFiles="1"
                                   acceptedFiles="image/*"
                                   :has-error="$v.companyLicenseForm.companyLicensePictureFile.id.$error"
                        ></drop-zone>
                    </div>
                </div>
                <div class="card-footer">
                    <div class="row">
                        <div class="col-12">
                            <div class="text-right">
                                <router-link tag="button"
                                        class="all-btn ml-auto"
                                        v-if="!hasCreate && hasPermission('V2_COMPANY_ADD')"
                                        :to="{path: '/company/license/add', query: {isCreate: true}}"
                                >
                                    <i class="fa fa-plus"></i>
                                    <span>{{$t('company.field.companyCreate')}}</span>
                                </router-link>
                                <button class="all-btn add-btn"
                                        v-else-if="hasCreate && hasPermission('V2_COMPANY_ADD')"
                                        @click="save"
                                        :disabled="processing"
                                >
                                    <i class="fa fa-check"></i>
                                    <span>{{$t('action.save')}}</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import DropZone from '@/views/dropZone/DropZone'
import Datepicker from 'vuejs-datepicker';
import {maxLength, required} from 'vuelidate/lib/validators';
import {formatDate, parseDate} from '@/shared/utils';

export default {
        name: "CompanyLicenseEdit",
        components: {
            DropZone,
            Datepicker
        },
        props: {
            data: Object
        },
        data() {
            return {
                processing: false,
                companyLicenseForm: {
                    id: null,
                    regNum: '',
                    serialNum: '',
                    dataNum: '',
                    giveName: '',
                    startDate: null,
                    endDate: null,
                    companyLicensePictureFile: {}
                },
                startDate: null,
                endDate: null,
                companyLicenseFiles: []
            }
        },
        validations() {
            return {
                companyLicenseForm: {
                    regNum: {
                        required,
                        maxLength: maxLength(255)
                    },
                    serialNum: {
                        required,
                        maxLength: maxLength(255)
                    },
                    dataNum: {
                        required,
                        maxLength: maxLength(255)
                    },
                    giveName: {
                        required,
                        maxLength: maxLength(255)
                    },
                    companyLicensePictureFile: {
                        id: {
                            required
                        }
                    }
                },
                startDate: {
                    required
                },
                endDate: {
                    required
                }
            }
        },
        computed: {
           hasCreate() {
             return this.$route.query.isCreate != null
           }
        },
        methods: {
            save() {
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return;
                }

                this.processing = true;

                this.companyLicenseForm.startDate = formatDate(this.startDate);
                this.companyLicenseForm.endDate = formatDate(this.endDate);

                this.$http.post('/company/license', this.companyLicenseForm)
                    .then(res => {
                        this.processing = false;
                        if (res.status === 200) {
                            this.$swal({
                                title: this.$t('messages.common.success'),
                                text: this.$t('messages.company.success'),
                                type: 'success'
                            });

                            this.$router.push('/company/profile')
                        }
                    }, ()=> {
                        this.$swal({
                            title: this.$t('messages.common.error'),
                            text: this.$t('messages.company.error'),
                            type: 'error'
                        });
                        this.processing = false;
                    });
            }
        },
        created() {

        },
        watch: {
            data: {
                immediate: true,
                handler(val) {
                    if (val) {
                        this.companyLicenseForm = val;
                        this.startDate = parseDate(val.startDate);
                        this.endDate = parseDate(val.endDate);
                        this.companyLicenseFiles.push(val.companyLicensePictureFile);
                    }
                }
            }
        }
    }
</script>

<style scoped>
    .license {
        background-color: #00897b;
    }
    .card .card-header span {
        color: white;
        font-weight: bold;
        font-size: 15px;
    }

    .card .card-footer {
        background-color: #f2f2f2;
    }
</style>